import { getApplicationSourceDisplay } from "@/helpers/application-source.helper"
import { SourceControlIcon, VmIcons } from "@/icons"
import { IconTextCell } from "@/molecules/IconTextCell"
import { ImageIcon } from "../../../../../icons/Images"

import type { ResourceComponent } from "."

export const Resource: ResourceComponent = (props) => {
  const { type, name, sourceControl, imageSource, subjectType } = props
  const applicationSourceDisplay = getApplicationSourceDisplay(props)

  if (applicationSourceDisplay) {
    return (
      <IconTextCell
        noTooltip
        icon={<applicationSourceDisplay.Icon />}
        text={name}
      />
    )
  }

  if (type === "ImageRepository") {
    if (!imageSource) return null
    return (
      <IconTextCell
        noTooltip
        icon={<ImageIcon imageSource={imageSource} />}
        text={name}
      />
    )
  }

  if (type === "Vm") {
    return (
      <IconTextCell
        noTooltip
        icon={<VmIcons type={subjectType} />}
        text={name}
      />
    )
  }

  return (
    <IconTextCell
      noTooltip
      icon={<SourceControlIcon sourceControl={sourceControl} />}
      text={name}
    />
  )
}
